import { BankWithBranchDto } from '../../generated/auth/models/Sasfin/Wealth/Online/Infrastructure/Models/bank-with-branch-dto';

export interface IBankWithBranchesState {
  list: BankWithBranchDto[];
  loading: boolean;
}

export const initialUIState: IBankWithBranchesState = {
  list: [],
  loading: false,
};
